<template>
  <a :href="href" :target="blank ? '_blank' : null">
    <el-dropdown-item class="dropdown-item" @click.native="cleanupNav">
      <i v-if="elementIcon" :class="elementIcon"></i>
      <icon v-else :glyph="icon" size="20" />
      <span>{{ $t(token) }}</span>
    </el-dropdown-item>
  </a>
</template>

<script>
import { datadogRum } from '@datadog/browser-rum'

export default {
  name: 'TopToolbarUserNavItem',

  props: {
    href: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    elementIcon: {
      type: String,
      required: false
    },
    token: {
      type: String,
      required: true
    },
    blank: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  mounted() {
    /*
      When TopToolBar is loaded we add a listener for hiding the default button
      when closing the Zendesk widget
     */
    if ('zE' in window) {
      window.zE('webWidget:on', 'close', function() {
        window.zE('webWidget', 'hide')
      })
    }
  },

  methods: {
    cleanupNav(event) {
      if (this.href === '/logout') {
        window.sessionStorage.removeItem(
          this.$store.getters.projectId + '-active-nav-item'
        )
        datadogRum.stopSession()
      } else if (this.href === '/help') {
        event.preventDefault()
        this.$zendesk.show()
        this.$zendesk.open()
      }
    }
  }
}
</script>

<style scoped>
.dropdown-item {
  padding: 0 15px;
  font-size: 14px;
  height: 40px;
}

.dropdown-item img {
  width: 20px;
  height: 20px;
  vertical-align: middle;
}

.dropdown-item span {
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 14px;
  vertical-align: middle;
  margin-left: 12px;
}

.dropdown-item:hover,
.dropdown-item:focus {
  color: unset;
  background-color: #e6f3fb;
}

.dropdown-item > .icon {
  vertical-align: middle;
}

.el-dropdown-menu__item i {
  font-size: 19px;
  vertical-align: middle;
  margin-right: 0px;
}
</style>



// WEBPACK FOOTER //
// src/common/components/navigation/TopToolbarUserNavItem.vue